



























































import { mapActions, mapMutations, mapGetters } from 'vuex'
import mixins from 'vue-typed-mixins'
import TopListItem from '@/components/TopListItem.vue'
import Spinner from '@/components/Spinner.vue'
import ScrollMixin from '@/mixins/ScrollMixin'
import OverlayPageModal from '@/components/OverlayPageModal.vue'
import User from '@/views/User.vue'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'
import UserActionMixin from '@/mixins/UserActionMixin'
import OverlayPageModalMixin from '@/mixins/OverlayPageModalMixin'
import { sleep } from '@/utils/helpers'

export default mixins(
  ScrollMixin,
  UserActionMixin,
  OverlayPageModalMixin,
  VirtualScrollMixin
).extend({
  name: 'SearchName',
  components: {
    Spinner,
    TopListItem,
    OverlayPageModal,
    User
  },
  data() {
    return {
      fetchPayload: {
        url: '/top_user_data/',
        params: {}
      },
      name: this.$store.getters['SearchResultUser/searchName'],
      isLoading: false,
      isSearching: false,
      isActiveProfileModal: false,
      savedScrollY: -1
    }
  },
  computed: {
    ...mapGetters('SearchResultUser', ['enabledInfinite', 'entries', 'distance', 'searchName']),

    itemSize(): number {
      return 103
    }
  },
  beforeRouteEnter(_to, from, next) {
    next((vm: any) => {
      if (from.name !== 'user' || vm.entries.length === 0) {
        vm.fetchData()
      }
    })
  },
  created() {
    this.fetchPayload.params = {
      page: 'search',
      name: this.name,
      p: 0
    }
  },
  async mounted() {
    await this.$nextTick()
    // window に無限スクロールをセット
    this.$_setHandleScroll(1000, this.handleInfinite)
  },
  methods: {
    ...mapActions('SearchResultUser', ['getEntries', 'infinite']),
    ...mapMutations('SearchResultUser', ['setSearchName']),

    fetchData(): Promise<any> {
      return this.getEntries(this.fetchPayload)
    },

    /**
     * 検索実行
     */
    async search() {
      if (this.isSearching) {
        return
      }
      window.scrollTo(0, 0)
      this.isSearching = true
      this.fetchPayload.params['name'] = this.name
      this.fetchPayload.params['p'] = 0
      this.setSearchName(this.name)
      await this.getEntries(this.fetchPayload)
      await sleep(500)
      this.isSearching = false
    },

    /**
     * ユーザをクリック
     */
    async handleUserClick(key: string, item: any) {
      const payload = {
        key: key,
        keys: [key],
        id: item.id,
        unreadCount: item.unread_count,
        profile: item.profile,
        fetchPayload: this.fetchPayload,
        backUrl: '/search/name'
      }
      if (this.$store.getters.UA_IS_ANDROID && this.$_isScrolling) {
        return
      }
      if (this.$store.getters.UA_IS_IOS) {
        this.$_jumpToProfile(payload.key, payload.id)
      } else {
        payload['pushUrl'] = `#/user/${payload.id}`
        this.$_showOverlayProfileModal(payload)
      }
    },

    /**
     * 無限スクロール
     */
    async handleInfinite() {
      if (this.isLoading || !this.enabledInfinite) {
        return
      }
      this.isLoading = true
      await this.infinite({
        delay: 500,
        fetchPayload: this.fetchPayload
      })
      this.isLoading = false
    }
  }
})
